import { useContext, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { maxQuestionError } from '@api/surveys';
import { IconButton, OverlayPopover, PlusIcon } from '@utilities';

import { SurveyContext } from '../../../../utilities/context';

import styles from './_index.module.scss';

const AddQuestionIconButton = ({ className, onAddQuestion, onCreateQuestion }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const buttonRef = useRef();
  const { currentQuestionCount, instantSurveyType, maxQuestions } = useContext(SurveyContext);
  const isVideoSurvey = instantSurveyType?.id === 'video-survey-v3-instant-survey-type';
  const canAddQuestion = isVideoSurvey
    ? currentQuestionCount < 1
    : currentQuestionCount < maxQuestions;

  const handleOnAdd = () => {
    setIsPopoverOpen(false);
    onAddQuestion();
  };
  const handleOnCreate = () => {
    setIsPopoverOpen(false);
    onCreateQuestion();
  };

  return (
    <>
      <IconButton
        className={className}
        isDisabled={!canAddQuestion}
        onClick={() => setIsPopoverOpen(true)}
        ref={buttonRef}
        tooltip={canAddQuestion ? 'Add Question' : maxQuestionError}
      >
        <PlusIcon />
      </IconButton>
      <OverlayPopover
        className={styles['add-question-icon-button-dropdown']}
        isActive={isPopoverOpen}
        onHide={() => setIsPopoverOpen(false)}
        target={buttonRef?.current}
      >
        <ul>
          <li>
            <button onClick={handleOnCreate}>
              <span>Create Question</span>
              <PlusIcon />
            </button>
          </li>
          <li>
            <button onClick={handleOnAdd}>
              <span>Add From Library</span>
              <PlusIcon />
            </button>
          </li>
        </ul>
      </OverlayPopover>
    </>
  );
};

AddQuestionIconButton.propTypes = {
  className: PropTypes.string,
  onAddQuestion: PropTypes.func.isRequired,
  onCreateQuestion: PropTypes.func.isRequired,
};

export default AddQuestionIconButton;
